module.exports = __webpack_public_path__ + "img/icon_1.2cad23a9.webp";